import { Component, ElementRef, EventEmitter, HostListener, Input, Output, inject, signal } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { KNOWLEDGE_SOURCE_LABEL_KEYS, KnowledgeSource } from '../../../core/models/knowledge-source';

@Component({ selector: 'app-knowledge-source-selector', standalone: true, imports: [TranslocoPipe], templateUrl: './knowledge-source-selector.html' })
export class KnowledgeSourceSelector {
  private readonly element = inject(ElementRef<HTMLElement>);
  @Input({ required: true }) availableSources: KnowledgeSource[] = [];
  @Input({ required: true }) selectedSources: KnowledgeSource[] = [];
  @Output() selectedSourcesChange = new EventEmitter<KnowledgeSource[]>();
  protected readonly open = signal(false);
  protected readonly labelKeys = KNOWLEDGE_SOURCE_LABEL_KEYS;

  protected toggle(source: KnowledgeSource): void {
    const selected = this.selectedSources.includes(source);
    if (selected && this.selectedSources.length === 1) return;
    const next = selected
      ? this.selectedSources.filter(item => item !== source)
      : this.availableSources.filter(item => item === source || this.selectedSources.includes(item));
    this.selectedSourcesChange.emit(next);
  }

  protected isLastSelected(source: KnowledgeSource): boolean {
    return this.selectedSources.length === 1 && this.selectedSources.includes(source);
  }

  @HostListener('document:click', ['$event'])
  protected closeOnOutsideClick(event: Event): void {
    if (!this.element.nativeElement.contains(event.target as Node)) this.open.set(false);
  }

  @HostListener('document:keydown.escape')
  protected closeOnEscape(): void { this.open.set(false); }
}
